module.exports = __webpack_public_path__ + "media/db_pano.a9ad11b4.mp4";